export const normalizeCanonicalToOrigin = (canonical: string, origin: string): string => {
	const relativeCanonical = canonical.replace(/^(https|http)?:\/\/[^\/?]+\/?/, '');
	return origin ? `${origin}/${relativeCanonical}` : canonical;
};
